import React from 'react'
import {Col, DatePicker, Form, Input} from 'antd'
import {get} from 'lodash'
import {dateVal} from '../../../../modules/Utils'

const {TextArea} = Input

function FuelTokenForm(props) {
  const {getFieldDecorator} = props.form
  const formItemLayout = {
    labelCol: {
      xs: {span: 24},
      sm: {span: 6},
    },
    wrapperCol: {
      xs: {span: 24},
      sm: {span: 14, offset: 1},
    },
  }
  const {fuelToken} = props

  return (
    <Form>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Name">
          {getFieldDecorator('name', {
            initialValue: get(fuelToken, 'name'),
          })(<Input />)}
        </Form.Item>
      </Col>{' '}
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Code">
          {getFieldDecorator('code', {
            initialValue: get(fuelToken, 'code'),
          })(<Input />)}
        </Form.Item>
      </Col>{' '}
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Serial">
          {getFieldDecorator('serial', {
            initialValue: get(fuelToken, 'serial'),
          })(<Input />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Details">
          {getFieldDecorator('details', {
            initialValue: get(fuelToken, 'details'),
          })(<TextArea />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="Start date">
          {getFieldDecorator('date.registration', {
            initialValue: dateVal(fuelToken, 'date.registration'),
          })(<DatePicker style={{width: '100%'}} />)}
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item {...formItemLayout} label="End date">
          {getFieldDecorator('date.expiry', {
            initialValue: dateVal(fuelToken, 'date.expiry'),
          })(<DatePicker style={{width: '100%'}} />)}
        </Form.Item>
      </Col>
    </Form>
  )
}

FuelTokenForm.propTypes = {}
FuelTokenForm.defaultProps = {}

export default Form.create()((FuelTokenForm))
